import { Permission } from "../authSchema";
import { createContext, useContext } from "react";
import { FetcherBase } from "./fetcher";
import { authManager } from "../global";
import { Role } from "../auth/types";

export function useAuth(): Auth {
    return useContext(AuthContext);
}

export const AuthContext = createContext(undefined);

export class Auth extends FetcherBase {
    private _roles: Role[];
    private _rolesFetchFailed: boolean;

    constructor() {
        super();
        this._roles = [];
        this._rolesFetchFailed = false;
    }

    get isLoggedIn(): boolean {
        return authManager.isLoggedIn;
    }

    get hasConferenceRole(): boolean {
        return this._roles.length > 0;
    }

    /** True when the roles could not be fetched, which is not the same as the user having no roles. */
    get rolesFetchFailed(): boolean {
        return this._rolesFetchFailed;
    }

    hasPermission(permission: Permission): boolean {
        for (const role of this._roles) {
            if (role.permissions.includes(permission)) return true;
        }
        return false;
    }

    /** A copy holding the same data, so that React re-renders the consumers after a refetch. */
    clone(): Auth {
        const copy = new Auth();

        copy._roles = this._roles;
        copy._rolesFetchFailed = this._rolesFetchFailed;

        return copy;
    }

    async fetch(): Promise<void> {
        if (!this.isLoggedIn) return;

        try {
            this._roles = await authManager.fetchRoles();
            this._rolesFetchFailed = false;
        } catch (e) {
            // The application must still start, the missing roles are reported instead of the main page.
            console.error("failed to fetch the roles of the user", e);
            this._roles = [];
            this._rolesFetchFailed = true;
        }
    }
}
